import css from 'styled-jsx/css';

export default css`.home-banner-login {
    position: relative;
    &-container {
        width: 320px;
        height: 278px;
        position: absolute;
        top: 16px;
        right: 0;
    }
}
`